import Button from 'components/base/Button'
import { TRANSITIONS } from 'enums'
import { TranslationContext } from 'contexts/TranslationContext'
import React, { useContext } from 'react'
import { ReactComponent as CloseIcon } from '~/assets/settings/navigation_close.svg'
import './SettingsHead.scss'

const SettingsHead = ({
  caption, description, onClose, onDelete, type, onSelectSame, selectedAssetsByType, isMixedType,
}) => {
  const { t } = useContext(TranslationContext)
  const isTransition = Object.values(TRANSITIONS).includes(type)
  const count = isMixedType ? selectedAssetsByType?.count : selectedAssetsByType?.[type]

  return (
    <div className="settings-head allow-draggable">
      <div className="settings-head__row allow-draggable">
        <span className="settings-head__caption">{caption}</span>
        <div className="settings-head__close" onClick={onClose} title={t('SETTINGS_HEAD_BTN_CLOSE_TOOLTIP')}>
          <CloseIcon />
        </div>
      </div>
      <div className="settings-head__row allow-draggable">
        <div className="settings-head__descr allow-draggable">
          <span className="settings-head__descr-title allow-draggable">
            {t('SETTINGS_HEAD_TEXT_DESCRIPTION')}
            :
          </span>
          <p className="settings-head__descr-text allow-draggable">
            {description}
            <span>
              {isTransition
                ? `(${t('TRANSITION_FORM_SELECTED')} ${count})`
                : ''}
            </span>
          </p>
        </div>
        <div className="settings-head__btns allow-draggable" title={t('SETTINGS_HEAD_BTN_DELETE_TOOLTIP')}>
          <Button onClick={onDelete} border large data-lang-id="SETTINGS_HEAD_BTN_DELETE">{t('SETTINGS_HEAD_BTN_DELETE')}</Button>
        </div>
        {isTransition && (
          <div className="settings-head__btns select-same allow-draggable" title={t('SETTINGS_HEAD_BTN_SELECT_SAME_TOOLTIP')}>
            <Button
              onClick={onSelectSame}
              border
              large
              data-lang-id="SETTINGS_HEAD_BTN_SELECT_SAME"
              disabled={isMixedType}
            >
              {t('SETTINGS_HEAD_BTN_SELECT_SAME')}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default SettingsHead
